<template>
  <section class="templates-chooser">
    <div class="templates">
      <div class="templates-wrapper" v-if="!isMobile">
        <TemplateCard
          v-for="(item, index) in templates"
          :key="index"
          :data="item"
          @template-choosed="selectTemplate"
        />
      </div>
      <swiper
        v-else
        :options="sliderOptions"
        ref="slider"
        @slideChange="changeSlide"
      >
        <swiper-slide v-for="(item, index) in templates" :key="index">
          <TemplateCard
            :key="index"
            :data="item"
            @template-choosed="selectTemplate"
          />
        </swiper-slide>
        <div class="templates-pagination" slot="pagination"></div>
      </swiper>
      <div class="editor__buttons" v-if="isMobile">
        <button
          class="pBtn pBtn--blue"
          @click="selectTemplate(templates[currentSlide].id)"
        >
          Выбрать
        </button>
        <button
          class="pBtn pBtn--transparent"
          @click="openPreview(templates[currentSlide].preview_id)"
        >
          <svg-icon type="eye-black" />
          Предпросмотр
        </button>
      </div>
    </div>
    <div class="editor__buttons">
      <button class="editor__back pBtn" @click="$router.go(-1)">
        <svg-icon type="back" />
        Назад
      </button>
    </div>
  </section>
</template>
<script type="text/javascript">
import "swiper/dist/css/swiper.css";
import { mapActions, mapState } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import TemplateCard from "./TemplateCard";

export default {
  components: { TemplateCard, swiper, swiperSlide },
  data() {
    // В коллбеках swiper this переопределяется почему-то
    return {
      isMobile: window.innerWidth < 768,
      sliderOptions: {
        // width: 270,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: -15,
        pagination: {
          el: ".templates-pagination",
          clickable: true
        }
      },
      //for mobile
      currentSlide: 0
    };
  },
  props: ["isWizard"],
  computed: {
    ...mapState({
      page: state => state.page,
      templates: state => {
        if (state.constructorData) return state.constructorData.templates;
        else return null;
      }
    }),
    swiper() {
      return this.$refs.slider.swiper;
    }
  },
  methods: {
    openPreview(id) {
      const win = window.open(
        `${location.protocol}//${location.host}/preview/${id}`,
        "_blank"
      );
      win.focus();
    },
    ...mapActions(["syncTemplate"]),
    selectTemplate(id) {
      this.$emit("templateWasSelected");
      this.syncTemplate({
        id: this.page.id,
        template: id
      });
      if (this.isWizard) {
        this.$store.dispatch("wizardStepChange", 3);
        this.$router.push("/wizard/3");
      }
    },
    changeSlide() {
      this.currentSlide = this.$refs.slider.swiper.activeIndex;
    }
  },
  mounted() {
    // this.templates = templates;
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/vars.scss";

.icon {
  margin: 0 10px;
}

h1 {
  @media #{$mobile} {
    font-size: 33px;
  }
}

.page-wrapper {
}

.templates {
  overflow: hidden;
  @media #{$mobile} {
    overflow: visible;
  }
  &-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    @media #{$mobile} {
      flex-flow: column nowrap;
    }
  }
  &__buttons {
    background: #ffffff;
    padding: 30px 0;
    display: flex;
    justify-content: space-between;
    @media #{$mobile} {
      flex-direction: column-reverse;
      padding: 0 15px;
    }
  }

  &__back {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 18px;
    background: transparent;
    border: none;
    position: relative;
    cursor: pointer;
    @media #{$mobile} {
      margin-bottom: 30px;
    }

    span {
      margin-right: 10px;
    }
  }
}

//слайдер
.swiper-slide {
  transition: all 0.3s ease;
}
.swiper-slide-next,
.swiper-slide-prev {
  transform: scale(0.8);
}
.swiper-container {
  overflow: visible;
}
.templates-pagination {
  text-align: center;
  margin-bottom: 60px;
}
/deep/ .swiper-pagination-bullet {
  width: 9px;
  height: 9px;
  opacity: 1;
  margin: 0 5px !important;
  background: #c4c4c4;
  &-active {
    background: #000000;
  }
}

.pBtn {
  width: 100%;
  margin-bottom: 10px;
}
</style>
